<template>
  <div class="tab-buttons">
    <component
      :is="getTabComponentName(tab)"
      v-for="(tab, index) in tabs"
      :key="index"
      :to="getTabTo(tab)"
      class="tab-button"
      active-class="tab-button--active"
      :class="{
        'tab-button--active': !tab.to && currentTab === index,
        'tab-button--disabled': tab.disabled
      }"
      :disabled="tab.disabled"
      @click="handleClickTab($event, index)"
    >
      {{ tab.label }}
    </component>
  </div>
</template>

<script>
export default {
  name: 'TabButtons',
  props: {
    defaultTab: {
      type: [String, Number],
      default: 0
    },
    tabs: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  data() {
    return {
      currentTab: this.defaultTab
    }
  },
  methods: {
    getTabTo(tab) {
      return {
        path: tab.to,
        query: this.$route.query
      }
    },
    handleClickTab(index) {
      if (!this.tabs[index].disabled && index !== this.currentTab) {
        this.currentTab = index

        this.$emit('changeTab', index)
      }
    },
    getTabComponentName(tab) {
      return tab.disabled || !tab.to ? 'button' : 'router-link'
    }
  }
}
</script>

<style lang="scss" scoped>
@use '@/../static/stylesheets/variables' as *;

$tab-button-background-color: #ebebeb;
$tab-button-border-color: $theme-primary-color;

.tab-buttons {
  display: flex;
  border-bottom: 1px solid $tab-button-border-color;
  margin-bottom: 1.5rem;
  height: 40px;
}

.tab-button {
  display: flex;
  background-color: $tab-button-background-color;
  border: 1px solid transparent;
  border-bottom-color: $tab-button-border-color;
  border-radius: 4px 4px 0px 0px;
  margin: 0 0 -1px 0;
  color: #B0B0B0 !important;
  font-weight: bold;
  font-size: 0.625rem;
  letter-spacing: 1.33333px;
  font-family: Roboto, sans-serif;
  text-transform: uppercase;
  padding: 0.4375rem 1.5rem;
  height: 40px;
  cursor: pointer;
  align-items: center;
  user-select: none;

  &:hover {
    color: $theme-primary-color !important;
  }

  &--active {
    cursor: default;
    border-color: $tab-button-border-color;
    border-bottom-color: $tab-button-background-color;
    color: $theme-primary-color !important;

    &:hover,
    &:active {
      color: #7a7a7a;
    }
  }

  &--disabled {
    opacity: 0.5;
    cursor: not-allowed;

    &:hover {
      color: #B0B0B0 !important;
    }
  }
}
</style>
